import {Component, OnInit} from '@angular/core';
import {Router, RouterLink, RouterOutlet, UrlTree} from '@angular/router';
import {APP_ROUTES} from '../../Shared/Constants/APP_ROUTES';
import {FooterComponent} from "../../Shared/Components/footer/footer.component";
import {SessionServiceService, SessionsFields} from "../../Shared/Services/session-service.service";
import {PAGE_STATES} from "../../Shared/Constants/SELECT_CONSTS";

@Component({
    selector: 'app-hydraulic-selection-page',
    imports: [RouterOutlet, RouterLink, FooterComponent],
    templateUrl: './hydraulic-selection-page.component.html',
    styleUrl: './hydraulic-selection-page.component.scss'
})
export class HydraulicSelectionPageComponent implements OnInit {
  currentPath: string = '';


  constructor(private router: Router, private sessionService: SessionServiceService) {
  }

  ngOnInit(): void {//Устанавливаем состояния страниц по умолчанию, для тех страниц, которые не были еще посещены
    const states: string[] = [APP_ROUTES.FFS, APP_ROUTES.HVAC, APP_ROUTES.WATER_DISPOSAL, APP_ROUTES.WATER_SUPPLY];
    const currStates: string[] = [];
    for (let state of states) {
      let currState = this.sessionService.getValue<string>(state, SessionsFields.state);
      if (!currState) currStates.push(state);
    }
    for (let state of currStates) {
      switch (state) {
        case APP_ROUTES.FFS:
          this.sessionService.setValue(state, SessionsFields.state, PAGE_STATES.ffs_installation);
          break;
        case APP_ROUTES.HVAC:
          this.sessionService.setValue(state, SessionsFields.state, PAGE_STATES.hvac_dryRotor);
          break;
        case APP_ROUTES.WATER_DISPOSAL:
          this.sessionService.setValue(state, SessionsFields.state, PAGE_STATES.water_disposal_pump);
          break;
        case APP_ROUTES.WATER_SUPPLY:
          this.sessionService.setValue(state, SessionsFields.state, PAGE_STATES.water_supply_pump);
          break;
      }
    }

  }

  onEnterNavigate() {
    const tree: UrlTree = this.router.parseUrl(this.router.url);
    let urlSegments = tree.root.children['primary'].segments.map((segment) => segment.path);
    this.router.navigate(urlSegments.slice(0, -1));
  }

  onPathChange($component: any) {
    if ($component.routeName) {
      setTimeout(() => {
        this.currentPath = $component.routeName;
      }, 0);
    }
  }

  protected readonly APP_ROUTES = APP_ROUTES;
  protected readonly SELECTION_STATES = SELECTION_STATES;
}

export const SELECTION_STATES = {
  SELECT: 'select',
  ENTER: 'enter',
  RESULT: 'result',
};
